import React from 'react';

// 官網連結。地球儀。
const IconGlobe = ({ onClick }) => {
	return (
		<div className='IconGlobe' onClick={onClick}>
			<svg
				width='20'
				height='20'
				viewBox='0 0 24 24'
				fill='none'
				stroke='#333333'
				strokeWidth='1.6'
				strokeLinecap='round'
				strokeLinejoin='round'
				xmlns='http://www.w3.org/2000/svg'
			>
				<circle cx='12' cy='12' r='9' />
				<path d='M3 12h18' />
				<path d='M12 3a13.5 13.5 0 0 1 0 18a13.5 13.5 0 0 1 0-18Z' />
			</svg>
		</div>
	);
};

export default IconGlobe;
